/**
 * Leads ganhos — /crm/ganhos. Wrapper fino sobre LeadsListaTerminal
 * (tipo="ganhos"): leads que viraram cliente, ocultos do board ativo.
 * Somente leitura (lead ganho permanece ganho).
 */
import React from "react";

import LeadsListaTerminal from "./LeadsListaTerminal";

function LeadsGanhos() {
  return <LeadsListaTerminal tipo="ganhos" />;
}

export default LeadsGanhos;
